module.exports = __webpack_public_path__ + "img/default.70f98a8a.png";